import { CellItem } from '@components/UI-Components/HierarchyWiseItemsTable/components/Row/Cell'
import useViewContext from '@modules/order/hooks/use-view-context'
import { useObserver } from 'mobx-react-lite'
import React, { FC } from 'react'
import HierarchyCell from '@modules/order/components/CellTemplates/components/HierarchyCell/HierarchyCell'
import FieldSkeleton from '@api/order/components/CellLoaders/FieldSkeleton'
import { EnhancedListUIStore } from '@modules/showroom/EnhancedOrder/stores/EnhancedListView/EnhancedListUIStore'
import { CentricTypography as Typography } from '@core/component/CentricTypography'
import { CATEGORY_INTERNAL_SEPERATOR } from '@components/UI-Components/HierarchyWiseItems/constants'
import formatCurrencyValueByLocale from '@utils/format-currency-value-by-locale'
import { getKPICurrency } from '@modules/order/utils/get-kpi-currency'
import useOrderContext from '@modules/order/hooks/use-order-context'
import { nav } from '@stores'

const EnhancedHierarchyCurrency: FC<CellItem> = ({ rowData, column }) =>
  useObserver(function useHook() {
    const { uiStore } = useViewContext()
    const {
      uiStore: {
        dataStore: { summary }
      }
    } = useOrderContext()
    const {
      getOrderHierarchyKPIs,
      dataStore: { heirarchy }
    } = uiStore as EnhancedListUIStore<any>
    const hierarchy = getOrderHierarchyKPIs(rowData?.name, heirarchy)
    const currency = getKPICurrency(nav.queryParams.orderType, summary)
    const isMainHeirarchy = !rowData?.name?.includes(CATEGORY_INTERNAL_SEPERATOR)
    if (!rowData) {
      return (
        <HierarchyCell>
          <FieldSkeleton />
        </HierarchyCell>
      )
    }
    return (
      <HierarchyCell>
        <Typography variant={isMainHeirarchy ? 'subtitle1' : 'caption'}>
          {formatCurrencyValueByLocale(currency, hierarchy?.[column.field] || 0)}
        </Typography>
      </HierarchyCell>
    )
  })

export default EnhancedHierarchyCurrency
